/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";
import InfoPopUp from "../../commonComponents/infoPopUp";

class Faq extends Component {
  state = {
    data: {
      questionEn: "",
      questionAr: "",
      questionKu: "",
      answerEn: "",
      answerAr: "",
      answerKu: "",
    },

    contentHeader: "FAQs",
    addButtonLabel: "Add Question",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/getfaqs",
    singleItemUrl: "/api/data/getfaq",
    addUrl: "/api/data/addfaq",
    editUrl: "/api/data/editfaq",
    deleteUrl: "/api/data/deletefaq",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Question",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Question",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    tableData: [],
  };

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.questionAr"),
        field: "QUESTION_AR",
      },
      {
        id: 2,
        label: t("col.answerAr"),
        field: "ANSWER_AR",
      },
      {
        id: 3,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 4,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 5,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              <div className="inner" title="More Info">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => {
                    this.handleMoreInfo(data);
                  }}
                >
                  <i className="fa fa-info" />
                </button>
              </div>
              {sysJwt.isAuthorized(["CB06"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB07"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  handleMoreInfo(row) {
    const jsonData = {
      "Question En": row.QUESTION_EN,
      "Answer En": row.ANSWER_EN,
      "Question Ku": row.QUESTION_KU,
      "Answer Ku": row.ANSWER_KU,
    };

    confirmAlert({
      title: row.QUESTION_AR,
      childrenElement: () => (
        <InfoPopUp
          jsonData={jsonData}
          titlesColumnSize={4}
          valuesColumnSize={8}
          popUpWidth="600px"
        />
      ),
      buttons: [
        { label: this.props.t("btn.close"),
          onClick: () => {
            null;
          },
        },
      ],
    });
  }

  componentDidMount() {
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
      allClaims: [],
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["questionEn"] = apiResponse.data.respData.data[0].QUESTION_EN;
      data["questionAr"] = apiResponse.data.respData.data[0].QUESTION_AR;
      data["questionKu"] = apiResponse.data.respData.data[0].QUESTION_KU;
      data["answerEn"] = apiResponse.data.respData.data[0].ANSWER_EN;
      data["answerAr"] = apiResponse.data.respData.data[0].ANSWER_AR;
      data["answerKu"] = apiResponse.data.respData.data[0].ANSWER_KU;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }
    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.faqs")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB05"]) && (
              <Button
                label={t("pages.addFaq")}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "questionEn",
                label: t("col.questionEn"),
                disabled: false,
              },
              {
                type: "text",
                id: "questionAr",
                label: t("col.questionAr"),
                disabled: false,
              },
              {
                type: "text",
                id: "questionKu",
                label: t("col.questionKu"),
                disabled: false,
              },
              {
                type: "text",
                id: "answerEn",
                label: t("col.answerEn"),
                disabled: false,
              },
              {
                type: "text",
                id: "answerAr",
                label: t("col.answerAr"),
                disabled: false,
              },
              {
                type: "text",
                id: "answerKu",
                label: t("col.answerKu"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(Faq);
